import { render } from "./MtnIvoryCoastPrizes.vue?vue&type=template&id=747d5da4&scoped=true"
import script from "./MtnIvoryCoastPrizes.vue?vue&type=script&lang=js"
export * from "./MtnIvoryCoastPrizes.vue?vue&type=script&lang=js"

import "./MtnIvoryCoastPrizes.vue?vue&type=style&index=0&id=747d5da4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747d5da4"]])

export default __exports__